import { Box, Center, Container, Heading, Text } from '@chakra-ui/react';
import PageHeader from 'components/page-header/PageHeader';
import PageTitleMobile from 'components/page-header/PageTitleMobile';
import { withIronSessionSsr } from 'iron-session/next';
import RootLayout from 'layouts/RootLayout';
import { sessionOptions } from 'libs/iron-session';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import Image from 'next/image';
import { NextPageWithLayout } from './_app';
import { useTranslation } from 'react-i18next';

const HowToOrderSection = ({
  title,
  description,
  image,
}: {
  title: string;
  description: string;
  image?: string;
}) => {
  return (
    <Box>
      <Heading fontWeight="500" mb={3} fontSize="xl" color="primary.500">
        {title}
      </Heading>
      <Text mb={5}>{description}</Text>
      {image && (
        <Center>
          <Image
            src={image}
            width={1000}
            height={754}
            priority
            quality={100}
            alt=""
          />
        </Center>
      )}
    </Box>
  );
};

const HowToBuyPage: NextPageWithLayout = () => {
  const { t } = useTranslation(['common', 'how-to-order']);

  return (
    <>
      <Head>
        <title>{t('how-to-order:how-to-order:title')} | แลมป์ตั้น</title>
      </Head>
      <Box>
        <PageHeader title={t('how-to-order:how-to-order:title')}></PageHeader>
        <PageTitleMobile>
          {t('how-to-order:how-to-order:title')}
        </PageTitleMobile>
        <Container
          pt={{
            base: 8,
            md: 12,
          }}
          pb={{
            base: 8,
            md: 20,
          }}
        >
          {/* <Heading
            fontWeight="500"
            mb={8}
            fontSize="xl"
            display={{
              base: 'none',
              md: 'block',
            }}
          >
            สำหรับเว็บไซต์บน Desktop
          </Heading>
          <Heading
            fontWeight="500"
            mb={8}
            fontSize="xl"
            display={{
              base: 'block',
              md: 'none',
            }}
          >
            สำหรับเว็บไซต์บน Mobile
          </Heading> */}
          <Box mb={10}>
            <HowToOrderSection
              title={`${t('how-to-order:how-to-order:steps-title')} 1`}
              description={t('how-to-order:how-to-order:steps:1')}
              image="/pages/how-to-buy/1-how-to-buy.png"
            ></HowToOrderSection>
          </Box>
          <Box mb={10}>
            <HowToOrderSection
              title={`${t('how-to-order:how-to-order:steps-title')} 2`}
              description={t('how-to-order:how-to-order:steps:2')}
              image="/pages/how-to-buy/2-how-to-buy.png"
            ></HowToOrderSection>
          </Box>
          <Box mb={10}>
            <HowToOrderSection
              title={`${t('how-to-order:how-to-order:steps-title')} 3`}
              description={t('how-to-order:how-to-order:steps:3')}
              image="/pages/how-to-buy/3-how-to-buy.png"
            ></HowToOrderSection>
          </Box>
          <Box mb={10}>
            <HowToOrderSection
              title={`${t('how-to-order:how-to-order:steps-title')} 4`}
              description={t('how-to-order:how-to-order:steps:4')}
              image="/pages/how-to-buy/4-how-to-buy.png"
            ></HowToOrderSection>
          </Box>
          <Box mb={10}>
            <HowToOrderSection
              title={`${t('how-to-order:how-to-order:steps-title')} 5`}
              description={t('how-to-order:how-to-order:steps:5')}
              image="/pages/how-to-buy/5-how-to-buy.png"
            ></HowToOrderSection>
          </Box>
          <Box mb={10}>
            <HowToOrderSection
              title={`${t('how-to-order:how-to-order:steps-title')} 6`}
              description={t('how-to-order:how-to-order:steps:6')}
              image="/pages/how-to-buy/6-how-to-buy-truemoney.png"
            ></HowToOrderSection>
          </Box>
        </Container>
      </Box>
    </>
  );
};

HowToBuyPage.getLayout = (page) => {
  return <RootLayout>{page}</RootLayout>;
};

export const getServerSideProps = withIronSessionSsr(async function ({
  locale,
}) {
  const _locale = locale || 'th';

  return {
    props: {
      ...(await serverSideTranslations(_locale, ['common', 'how-to-order'])),
    },
  };
},
sessionOptions);

export default HowToBuyPage;
